module.exports = __webpack_public_path__ + "img/polkadot.6f005868.png";